import { DomHandler } from 'primeng/dom';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[pBPaaSFocusTrap]',
  host: {
    class: 'p-element'
  }
})
export class FocusTrapDirective {
  /**
   * When set as true, focus wouldn't be managed.
   */
  @Input() pBPaaSFocusTrapDisabled: boolean = false;

  constructor(public el: ElementRef) { }

  @HostListener('keydown.tab', ['$event'])
  @HostListener('keydown.shift.tab', ['$event'])
  onkeydown(e: KeyboardEvent) {
    if (this.pBPaaSFocusTrapDisabled !== true) {
      e.preventDefault();
      const focusableElements = DomHandler.getFocusableElements(this.el.nativeElement);
      // console.dir(focusableElements);

      const focusableElement = DomHandler.getNextFocusableElement(this.el.nativeElement, e.shiftKey);
      setTimeout(() => {
        if (focusableElement) {
          focusableElement.focus();
          focusableElement.select?.();
        }
      }, 0);
    }
  }
}
